import { RouteRecordRaw } from 'vue-router'
import PageMyTasks from '../pages/PageMyTasks.vue'
import PageStores from '../pages/PageStores.vue'
import PageTimeline from '../pages/PageTimeline.vue'
import PageStoreProfile from '../pages/PageStoreProfile.vue'
import PageTaskProfile from '../pages/PageTaskProfile.vue'
import PageInventory from '../pages/PageInventory.vue'
import PageMessaging from '../pages/PageMessaging.vue'
import PageMessage from '../pages/PageMessage.vue'
import PagePreviousTimesheets from '../pages/PagePreviousTimesheets.vue'
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: PageTimeline },
      { name: 'userInfo', path: '/user', component: () => import('pages/PageUserInfo.vue') },
      {
        name: 'previous_activities',
        path: '/previous_activities',
        component: PagePreviousTimesheets,
      },
      {
        name: 'previous_activity',
        path: '/previous_activities/:id',
        component: () => import('pages/PageEditTimesheet.vue'),
      },
      { path: 'tasks', component: PageMyTasks },
      { path: 'stores', component: PageStores },
      { path: 'stores/:id', component: PageStoreProfile },
      { path: 'tasks/:id', component: PageTaskProfile },
      { path: 'inventory', component: PageInventory },
      { path: 'preferences', component: () => import('pages/PagePreferences.vue') },
      { path: 'messaging', component: PageMessaging },
      { name: 'message', path: 'messaging/:id', component: PageMessage },
      { path: 'expenses', component: () => import('pages/PageExpenses.vue') },
      { path: 'recap', component: () => import('pages/PageRecapPreview.vue') },
    ],
  },
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [{ path: '', component: () => import('pages/PageLogin.vue') }],
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/PageError404.vue'),
  },
]

export default routes
